import { useAppSelector } from "@redux/hook"
import useStorage from "./useStorage"
import { selectPlayer, selectPlayerStatus } from "@redux/slices/playerSlice"
import useAnalytics from "./useAnalytics"

const usePlayerStatus = () => useAppSelector(selectPlayerStatus)
const usePlayer = () => useAppSelector(selectPlayer)

export { useStorage, usePlayer, usePlayerStatus, useAnalytics }